import React from "react";
import { DoubleRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

export const jobStatusNew = "New";
export const jobStatusAssigned = "Assigned";
export const jobStatusInProgress = "In Progress";
export const jobStatusInReview = "In Review";
export const jobStatusInRebuttal = "In Rebuttal";
export const jobStatusInLSO = "In LSO";
export const jobStatusReadyForNextStep = "Ready for next step";
export const jobStatusDelivered = "Delivered";
export const jobStatusExtensionRequested = "Extension Requested";
export const jobStatusPendingQueries = "Pending Queries";
export const jobStatusReassign = "Reassign";
export const jobStatusCompleted = "Completed";
export const jobStatusRejected = "Rejected";

export const jobStatus = [
    {
        value: jobStatusNew,
        key: jobStatusNew,
        name: jobStatusNew,
        text: jobStatusNew,

        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusAssigned,
        key: jobStatusAssigned,
        name: jobStatusAssigned,
        text: jobStatusAssigned,

        color: "#9c607a",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusInProgress,
        key: jobStatusInProgress,
        name: jobStatusInProgress,
        text: jobStatusInProgress,

        color: "#60a064",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusInReview,
        key: jobStatusInReview,
        name: jobStatusInReview,
        text: jobStatusInReview,

        color: "#ddc652",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusInRebuttal,
        key: jobStatusInRebuttal,
        name: jobStatusInRebuttal,
        text: jobStatusInRebuttal,

        color: "#87d068",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusInLSO,
        key: jobStatusInLSO,
        name: jobStatusInLSO,
        text: jobStatusInLSO,

        color: "#87d068",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusReadyForNextStep,
        key: jobStatusReadyForNextStep,
        name: jobStatusReadyForNextStep,
        text: jobStatusReadyForNextStep,

        color: "#10cee9",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusExtensionRequested,
        key: jobStatusExtensionRequested,
        name: jobStatusExtensionRequested,
        text: jobStatusExtensionRequested,

        color: "#cb6252",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusPendingQueries,
        key: jobStatusPendingQueries,
        name: jobStatusPendingQueries,
        text: jobStatusPendingQueries,

        color: "#cb6252",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusReassign,
        key: jobStatusReassign,
        name: jobStatusReassign,
        text: jobStatusReassign,
        color: "#cb6252",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: jobStatusCompleted,
        key: jobStatusCompleted,
        name: jobStatusCompleted,
        text: jobStatusCompleted,
        color: "#1058e9",
        ico: <ExclamationCircleOutlined />,
        selectable: false,
    },
    {
        value: jobStatusDelivered,
        key: jobStatusDelivered,
        name: jobStatusDelivered,
        text: jobStatusDelivered,

        color: "#108ee9",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },

    {
        value: jobStatusRejected,
        key: jobStatusRejected,
        name: jobStatusRejected,
        text: jobStatusRejected,
        color: "#f50",
        ico: <ExclamationCircleOutlined />,
        selectable: true,
        style: { color: "red" },
    },
];

export const isFinalStatus = (status) => {
    if (status == jobStatusCompleted || status === jobStatusDelivered || status == jobStatusRejected) {
        return true;
    }
    return false;
};

export const getStatusColor = (status) => {
    const st = jobStatus.find((e) => e.key == status);
    return st ? st.color : "";
};
